import { render, staticRenderFns } from "./StopListTable.vue?vue&type=template&id=18b45b5a&scoped=true&"
import script from "./StopListTable.vue?vue&type=script&lang=js&"
export * from "./StopListTable.vue?vue&type=script&lang=js&"
import style0 from "./StopListTable.vue?vue&type=style&index=0&id=18b45b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b45b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b45b5a')) {
      api.createRecord('18b45b5a', component.options)
    } else {
      api.reload('18b45b5a', component.options)
    }
    module.hot.accept("./StopListTable.vue?vue&type=template&id=18b45b5a&scoped=true&", function () {
      api.rerender('18b45b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/Components/StopListTable.vue"
export default component.exports